<template>
  <div id="billingBanner" v-if="show" :class="'alert-' + info.variant" class="alert m-0 rounded-0 py-2 px-3 d-flex flex-wrap align-items-center justify-content-between">
    <div class="mr-3">
      <strong>{{ info.label }}.</strong> {{ info.detail }}
    </div>
    <div class="mt-1 mt-sm-0">
      <a class="btn btn-sm" :class="info.variant === 'danger' ? 'btn-danger' : 'btn-primary'" :href="'/billing?ts=' + trailSystem.id">
        {{ info.action === 'manage' ? 'Update payment' : info.status === 'seasonal' ? 'Manage' : (info.status === 'paused' ? 'Reactivate' : 'Choose a plan') }}
      </a>
      <button v-if="!info.urgent || info.status === 'trial'" type="button" class="btn btn-sm btn-link text-muted" @click="dismissed = true" aria-label="Dismiss">Later</button>
    </div>
  </div>
</template>

<script>
// Shown to the trail system's managers (owner, trustees) when billing needs
// attention: trial ending within 7 days, payment failed, or paused.
import { describeBilling } from '../../assets/lib/billingStatus'

export default {
  data () {
    return { dismissed: false }
  },
  computed: {
    trailSystem () { return this.$store.state.trailSystem },
    info () { return describeBilling(this.trailSystem) },
    show () {
      if (this.dismissed || !this.trailSystem || !this.trailSystem.id) return false
      if (!this.$store.state.currentUser || !this.$store.state.currentRole) return false
      if (this.$store.state.embedMode) return false
      return ['paused', 'grace', 'seasonal'].includes(this.info.status) || (this.info.status === 'trial' && this.info.urgent) || (this.info.status === 'active' && this.info.urgent)
    }
  }
}
</script>

<style scoped>
#billingBanner { position: fixed; top: 0; left: 0; width: 100%; z-index: 1041; }
</style>
